import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import global from './global'
import { move } from './utils/common'
Vue.config.productionTip = false;

//全局组件
import lContainer from './components/lContainer.vue'
import lDialog from './components/lDialog.vue'
import affirm from './components/affirm.vue'
import lButton from './components/lButton.vue'
Vue.component('l-container', lContainer)
Vue.component('l-dialog', lDialog)
Vue.component('affirm', affirm)
Vue.component('l-button', lButton)
import popup from "@/components/popup/popup.js";
Vue.use(popup)

// 引入全局的图片
Vue.prototype.global = global;

// 移动弹窗的方法
Vue.prototype.$move = move;

//rem自适应
import "./utils/rem/rem";
//引入字体
import "./assets/font/fontStyle.less";
//axios
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "./server/request";
import { getUserNum, addUserRecord } from "./server/apiUrl"

Vue.prototype.$get = getRequest;
Vue.prototype.$post = postRequest;
Vue.prototype.$put = putRequest;
Vue.prototype.$delete = deleteRequest;
Vue.prototype.$getUserNum = getUserNum;
Vue.prototype.$addUserRecord = addUserRecord;

//echarts
import * as echarts from 'echarts';
Vue.prototype.echarts = echarts;
//element-ui
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// file-saver
import { saveAs } from "file-saver";
Vue.prototype.$saveAs = saveAs

Vue.prototype.$myMessage = (msg, time = 1000) => {
  Vue.prototype.$message({
    message: msg,
    duration: time
  })
}

import Slider from "@/components/slider/index.vue";
Vue.component('zx-slider', Slider)
import BigDataRoll from "@/components/BigDataRoll.vue";
Vue.component('big-data-roll', BigDataRoll)
import lDatePicker from "@/components/lDatePicker.vue";
Vue.component('l-date-picker', lDatePicker)
import EjectSelectList from "@/components/EjectSelectList.vue";
Vue.component('eject-select-list', EjectSelectList)

import directive from "@/utils/directive.js";
Vue.use(directive)
//自定义样式
import './assets/css/elpage.less'
import './assets/css/elCheck.less'
import './assets/css/btn.less'
import './assets/css/date.less'
import './assets/css/select.less'
import './assets/css/message.less'
import './assets/css/inputAndCheckbox.less'
import './assets/css/container.less'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
